import { Inject, Injector } from "@angular/core";
import { MAT_DIALOG_DATA } from "@angular/material/dialog";
import { IDialogData } from "../../viewer-components/interfaces/i-dialog-data";

export abstract class UploadLayerDialogComponent {
  urlType = "";

  url = "";

  protected constructor(
    @Inject(MAT_DIALOG_DATA) protected data: IDialogData,
    public injector: Injector,
  ) {
    this.url = data.url;
    this.urlType = data.urlType;
    this.injector = injector;
  }
}
